import axios from "axios";
import React ,{useState , useEffect}from "react";
import Pagination from "../pagination/pagination";
import './books.css'
import { API } from "../../const";
export default function Books(){
    window.scrollTo(0,0)
    const [books , setBooks] = useState([]);
    const [Loading , setLoading] = useState(false);
    const [currentPage , setCurrentPage] = useState(1);
    const [booksPerPage ] = useState(6);

    useEffect(()=>{
        const fetchBooks = async ()=>{
            setLoading(true);
            const res = await axios.get(`${API}/book/getAll?limit=100`);
            setBooks(res.data.data);
            setLoading(false);
        }
        fetchBooks();
    },[]);

    
    const indexOfLastPage = currentPage * booksPerPage;
    const indexOfFirstPage = indexOfLastPage - booksPerPage;
    const currentbooks = books.slice(indexOfFirstPage , indexOfLastPage);
    const paginate = PageNumber=> setCurrentPage(PageNumber)
    return(
        (Loading)?<p>Loading.....</p>:
        <div className ="books-page" style={{minHeight: '95vh',}}>
            <div className = 'header'>Books</div>
            <div className = 'all-books'>
                {
                    currentbooks.slice(0).reverse().map((book , index)=>{
                        return(
                            <div className='book' key={index}>
                                <img src={book.photo} alt='bookImage'/>
                                <div className="books-data">
                                    <p className='name'>{book.name}</p>
                                    <p>{book.des}</p>
                                    <a href={book.link} target='_block'>download</a>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <Pagination chaptersPerPage={booksPerPage} totalChapters={books.length} paginate={paginate}/>
        </div>
    );
}




